import { isGrouped } from '../../GanttVisualization.helper';
import { splitTextHTML } from '../../../../utils/lookahead-common';
import TooltipHTML from '../../../TooltipHTML';

import childArrow from '../../../../assets/img/newlookahead/name/child-arrow.png';
import { isFeatureOn } from '../../../../utils/featureUtils';

export const testIds = {
  RENDER_NAME_CONTAINER: 'RENDER_NAME_CONTAINER'
};

const RenderName = ({
  task = {},
  column = {
    width: 0
  },
  activities = [],
  gantt = {},
  t,
  projectState = {}
}) => {
  const dataTestId = 'data-testid="' + testIds.RENDER_NAME_CONTAINER + '"';
  if (!activities || !task) return `<div ${dataTestId}></div>`;
  /** Check if data is defined. Activity don't have this data */
  const item = task;

  if (!gantt) return `<div ${dataTestId}></div>`;

  /** calculate margin left according level */
  const itemLvl = item?.$level; // ? item.$level : 30
  let marginLeft = 26;
  if (task.is_parent) {
    marginLeft = 9;
  }

  const fixedPos = (16 * itemLvl || 30) + marginLeft;
  const fixedPosAct = fixedPos;
  const fixedPosTask = isGrouped() ? 60 : fixedPos + 40;

  const renderTaskNameInput = (
    html_collapse_expand = null
  ) => `<div class="gantt_tree_content" style="cursor: pointer">
                ${
                  task.parent &&
                  task.type === 'activitytask' &&
                  task.isChildTask
                    ? `<img style= "width:12px; margin-right: 6px, margin-left: ${
                        !html_collapse_expand ? '10px' : '1px'
                      }" src="${childArrow}" />`
                    : ''
                }
                ${task.name}
            </div>`;

  const splitActivityRoute = (activityRoute) => {
    if (projectState?.allProjects?.length > 0) {
      if ([54, 479].includes(projectState?.allProjects[0]?.companyId)) {
        if (activityRoute) {
          const pieces = activityRoute.split(' > ');
          if (pieces) {
            if (pieces.length > 3) {
              return (
                pieces[pieces.length - 3] +
                ' > ' +
                pieces[pieces.length - 2] +
                ' > ' +
                pieces[pieces.length - 1]
              );
            }
            return activityRoute;
          }
          return activityRoute;
        }
        return activityRoute;
      }
      return activityRoute;
    }
    return activityRoute;
  };

  const renderMain = () => {
    let prefix = `${item?.ganttId || item?.correlative_id}| `;
    if (isGrouped()) {
      prefix = '';
    }
    const activityIdStr = `${prefix}${item?.name}`;

    return `<div ${dataTestId}>
                <div
                    class="${
                      (isFeatureOn('enable_lwp_18')
                        ? 'custom-div-row-container'
                        : '') + ' text-btn-gantt-view'
                    }"
                    style="
                        color: #121212;
                        font-weight: 600;
                        position: relative;
                        left: ${fixedPosAct}px;
                        display: flex;
                        align-items: center;
                    "
                >
                    <span class="collapse-expand-gantt">
                        ${
                          item?.$open
                            ? '<div class="gantt_tree_icon gantt_close"></div>'
                            : '<div class="gantt_tree_icon gantt_open"></div>'
                        }
                    </span>

                    <span>
                        <span class="act-correlative-id">
                            <span class="main-activity-name">
                                ${splitTextHTML(
                                  activityIdStr,
                                  { ...column, width: column?.width },
                                  item?.id
                                )}
                            </span>
                            ${
                              isFeatureOn('enable_lwp_18')
                                ? `
                                <span class='main-activity-route'>
                                    ${splitTextHTML(
                                      splitActivityRoute(item?.activityRoute),
                                      column,
                                      item?.id
                                    )}
                                </span>
                            `
                                : ''
                            }
                        </span>
                    </span>

                </div>
            </div>`;
  };

  const renderActivityTask = () => {
    let html_collapse_expand =
      item?.is_parent || item?.isParentTask
        ? `<span class="collapse-expand-gantt expand-task">
                    ${
                      item?.$open
                        ? '<div class="gantt_tree_icon gantt_close"></div>'
                        : '<div class="gantt_tree_icon gantt_open"></div>'
                    }
                </span>`
        : '';

    const taskName = renderTaskNameInput(html_collapse_expand);
    if (isGrouped()) {
      html_collapse_expand = null;
    }

    // FIT LEVELS VISUAL
    let marginAdjust;
    if (task.is_parent && itemLvl >= 1) {
      marginAdjust = '-15px !important;';
    }

    return `<span ${dataTestId}>
                <div style="display:flex; align-items: center; margin-left: ${
                  task.is_parent && marginAdjust ? marginAdjust : '0px'
                }">
                    <span data-event-drawer="true" class="open-card-button-new custom-adjust-visual-tree"></span>
                    <span class="text-btn-gantt-view-new" style="display:flex; position: relative; left: ${
                      fixedPosTask * 0.5
                    }px;align-items: center">
                        ${html_collapse_expand}
                        ${taskName}
                    </span>
                </div>
            </span>`;
  };

  const renderMilestone = () => `<div>
                <div class="milestone-name-custom">
                    ${item?.name}
                </div>
            </div>`;

  const renderPending = () => {
    const pendingContent = `
                <div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;">
                    <span class="text-btn-gantt-view-new" style="display:flex; position: relative; left: ${fixedPosTask * 0.5}px;align-items: center">
                        <div class="gantt_tree_content task-name-pending">
                            ${item?.name}
                        </div>
                    </span>
                </div>`;

    return TooltipHTML({
      text: t('activity_pending_sir_actions_tooltip'),
      container: pendingContent,
      task_id: item?.id || 0,
      gantt: gantt,
      name: 'pending-tooltip'
    });
  };

  const renderNameColumn = () => {
    let isOdd = false;
    if (gantt.oddColsConfig && task.type === 'activitytask') {
      isOdd = gantt.oddColsConfig.name;
    }
    if (!item?.type) return renderMain();

    return `<div ${dataTestId} data-cell-type="name" data-task-id="${task.id}">
                <div
                    class="${!isOdd ? 'odd-col' : 'non-odd-col'}"
                >
                    ${item.modificationSource === 'pending' && item.type === 'activitytask' ? renderPending() : ''}
                    ${item.type === 'activitytask' ? renderActivityTask() : ''}
                    ${item.type === 'main' ? renderMain() : ''}
                    ${item.type === 'milestone' ? renderMilestone() : ''}
                </div>
            </div>`;
  };

  return renderNameColumn();
};

export default RenderName;
